import type {
  DeviceRequest,
  DeviceResponse,
  GetDeviceListRequestV2,
  GetListResponseOfDeviceSimpleResponse,
  GetListResponseOfSelectOption,
} from 'src/api/ProactApiClient';
import {deviceApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const deviceApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getDeviceSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      GetDeviceListRequestV2
    >({
      queryFn: clientQuery(params => deviceApiClient.listSelectOptions(params)),
      providesTags: ['Devices'],
    }),
    getDeviceListV2: builder.query<
      GetListResponseOfDeviceSimpleResponse,
      GetDeviceListRequestV2
    >({
      queryFn: clientQuery(params => deviceApiClient.listV2(params)),
      providesTags: ['Devices'],
    }),
    getDevice: builder.query<DeviceResponse, number>({
      queryFn: clientQuery(id => deviceApiClient.get(id)),
      providesTags: ['Devices'],
    }),
    createDevice: builder.mutation<DeviceResponse, DeviceRequest>({
      queryFn: clientQuery(request => deviceApiClient.create(request)),
      invalidatesTags: ['Devices'],
    }),
    updateDevice: builder.mutation<DeviceResponse, DeviceRequest>({
      queryFn: clientQuery(request => deviceApiClient.update(request)),
      invalidatesTags: ['Devices'],
    }),
    deleteDevice: builder.mutation<boolean, number>({
      queryFn: clientQuery(id => deviceApiClient.delete(id)),
      invalidatesTags: ['Devices'],
    }),
    updateDeviceActiveStatus: builder.mutation<
      DeviceResponse,
      {id: number; active: boolean}
    >({
      queryFn: clientQuery(({id, active}) =>
        deviceApiClient.updateActiveStatus(id, active)
      ),
      invalidatesTags: ['Devices'],
    }),
    verifyDevice: builder.mutation<DeviceResponse, number>({
      queryFn: clientQuery(id => deviceApiClient.verify(id)),
      invalidatesTags: ['Devices'],
    }),
  }),
});

export const {
  useGetDeviceSelectOptionsQuery,
  useGetDeviceListV2Query,
  useGetDeviceQuery,
  useCreateDeviceMutation,
  useUpdateDeviceMutation,
  useDeleteDeviceMutation,
  useUpdateDeviceActiveStatusMutation,
  useVerifyDeviceMutation,
} = deviceApi;
